import { CardVisaIcon } from './components/icons';
import { ICardIcon } from './types/CardIcon';

export enum EIcon {
  VISA = 'Visa',
}

export interface ICardIconProps extends ICardIcon {
  type: EIcon | string;
}

export default function CardIcon({ type, ...props }: ICardIconProps) {
  switch (type) {
    case EIcon.VISA:
      return <CardVisaIcon {...props} />;
    default:
      return <></>;
  }
}
